<script lang="ts" setup>
import './app.styl'

const info = import.meta.env
</script>

<template>
  <router-view />
  <div class="debug">
    {{ info }}
  </div>
</template>
